import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Form, Button } from "react-bootstrap";
import Navigation from "./Navigation";
import Swal from 'sweetalert2';
import { FaWallet } from 'react-icons/fa';
import AdminPageHeader from './AdminPageHeader';

function EditDeposit() {
  const { id } = useParams(); // ambil id dari URL (misal /deposit/edit/3)
  const [deposit, setDeposit] = useState(null);
  const [loading, setLoading] = useState(true);

  // state untuk form
  const [amount, setAmount] = useState("");
  const [status, setStatus] = useState("");
  const token = localStorage.getItem('sessionToken');

  useEffect(() => {
    const fetchDeposit = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_PRODUCT_URL}api/deposit/${id}`,
          {
                headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
            }
        );
        const data = await res.json();
        if (data.deposits && data.deposits.length > 0) {
          const dep = data.deposits[0];
          setDeposit(dep);
          setAmount(dep.amount);
          setStatus(dep.status);
        }
      } catch (error) {
        console.error("Error fetching deposit:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDeposit();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // kirim update ke API
    try {
      const res = await fetch(`${process.env.REACT_APP_API_PRODUCT_URL}api/deposit/approve/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          amount,
          status,
        }),
      });
      if (res.ok) {
        Swal.fire('Success!', 'Deposit updated successfully', 'success');
       
      } else {
        alert("Failed to update deposit");
      }
    } catch (error) {
      console.error("Error updating deposit:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      <Navigation />
      <Container fluid className="admin-page-shell mt-4 px-4">
        <AdminPageHeader
          icon={FaWallet}
          eyebrow="Finance administration"
          title={`Update Deposit #${id}`}
          description="Tinjau dan perbarui status deposit untuk memastikan proses persetujuan berjalan dengan tertib."
          breadcrumbs={[
            { label: 'Dashboard', to: '/dashboardadmin' },
            { label: 'Deposits', to: '/deposits' },
            { label: `Update Deposit #${id}` },
          ]}
        />

        {deposit ? (
          <div className="section-card">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Outlet ID</Form.Label>
                <Form.Control type="text" value={deposit.outlet_id} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="0">Pending</option>
                  <option value="1">Approved</option>
                  <option value="2">Rejected</option>
                </Form.Select>
              </Form.Group>

              <div className="form-actions">
                <Button type="submit" variant="primary">
                  Save Changes
                </Button>
              </div>
            </Form>
          </div>
        ) : (
          <p>Deposit not found</p>
        )}
      </Container>
    </div>
  );
}

export default EditDeposit;
